import { generateClient } from "aws-amplify/api";
import { setAutoSyncFormTemplatesLambda } from "../graphql/mutations";
import { Project } from "db/definitions";
import { recordSentry } from "./recordSentry";

const client = generateClient({ authMode: "userPool" });

async function handleSetOrRemoveAutoSyncFormTemplates(data: string[], project: Project, action: "set" | "remove") {
	try {
		await client.graphql({
			query: setAutoSyncFormTemplatesLambda,
			authMode: "userPool",
			variables: {
				projectId: project.id,
				formTemplateIds: data,
				action: action,
			},
		});
	} catch (error) {
		recordSentry({ error });
	}
}

export default handleSetOrRemoveAutoSyncFormTemplates;
